import React from 'react';

import { componentService } from '@core/js/services/component.service';
import { useUserSelector } from '@core/js/store/hooks/useUserSelector';

import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { useClubData } from '@interlayer/js/app/services/clubsService/useClubData';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const ClubName: React.FC = () => {
    const [{ data }] = useClubData();
    const homeVenue = useUserSelector((state) => state.userDetails.homeVenue);
    const [dTagDefaultHomeVenueCode = ''] = useDynamicTags([DYNAMIC_TAG_NAMES.defaultHomeVenueCode]);

    return (
        <div>{data.clubsObj?.[homeVenue || dTagDefaultHomeVenueCode]?.club_name}</div>
    );
};

componentService.registerWebContentComponents({ ClubName });
